import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import Home from "../components/Home";
import Portfolio from "../components/Portfolio";
import Contact from "../components/Contact";
import Footer from "../components/Footer";
import Logo26 from "../assets/Logo26.png";

const launchBenefits = [
  "Gestiona ligas y torneos",
  "Entrena, mejora y compite",
  "Controla tus estadísticas",
];

const AppLaunchVisual = () => (
  <div className="app-launch__visual-stage" aria-hidden="true">
    <div className="app-launch__grid"></div>
    <svg viewBox="0 0 640 420" className="app-launch__visual-svg" preserveAspectRatio="none">
      <defs>
        <linearGradient id="launchTrace" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" stopColor="rgba(0, 198, 207, 0)" />
          <stop offset="18%" stopColor="rgba(0, 198, 207, 0.9)" />
          <stop offset="58%" stopColor="rgba(111, 231, 237, 0.88)" />
          <stop offset="100%" stopColor="rgba(255, 255, 255, 0.12)" />
        </linearGradient>
        <radialGradient id="launchGlow" cx="50%" cy="50%" r="50%">
          <stop offset="0%" stopColor="rgba(111, 231, 237, 0.9)" />
          <stop offset="55%" stopColor="rgba(0, 198, 207, 0.24)" />
          <stop offset="100%" stopColor="rgba(0, 198, 207, 0)" />
        </radialGradient>
      </defs>
      <g className="app-launch__rings">
        <circle className="app-launch__ring app-launch__ring--outer" cx="320" cy="210" r="128" />
        <circle className="app-launch__ring app-launch__ring--mid" cx="320" cy="210" r="88" />
        <circle className="app-launch__ring app-launch__ring--inner" cx="320" cy="210" r="46" />
      </g>
      <path className="app-launch__beam" d="M132 132 L320 210 L508 108" />
      <path className="app-launch__beam app-launch__beam--alt" d="M88 246 L320 210 L548 296" />
      <path className="app-launch__beam app-launch__beam--soft" d="M238 338 L320 210 L402 326" />
      <path className="app-launch__trace" d="M28 318 C 132 250, 176 118, 296 140 S 458 318, 604 104" />
      <path className="app-launch__trace app-launch__trace--delay" d="M84 382 C 178 332, 258 318, 346 232 S 500 82, 598 144" />
      <path className="app-launch__trace app-launch__trace--soft" d="M58 110 C 178 130, 270 94, 360 170 S 516 266, 620 246" />
      <circle className="app-launch__core-glow" cx="320" cy="210" r="72" />
      <circle className="app-launch__node app-launch__node--core" cx="320" cy="210" r="16" />
      <circle className="app-launch__node app-launch__node--a" cx="132" cy="132" r="8" />
      <circle className="app-launch__node app-launch__node--b" cx="508" cy="108" r="8" />
      <circle className="app-launch__node app-launch__node--c" cx="88" cy="246" r="7" />
      <circle className="app-launch__node app-launch__node--d" cx="548" cy="296" r="7" />
      <circle className="app-launch__node app-launch__node--e" cx="238" cy="338" r="6" />
      <circle className="app-launch__node app-launch__node--f" cx="402" cy="326" r="6" />
    </svg>

    <div className="app-launch__signal app-launch__signal--left">Liga</div>
    <div className="app-launch__signal app-launch__signal--top">Stats</div>
    <div className="app-launch__signal app-launch__signal--right">Online</div>
    <div className="app-launch__signal app-launch__signal--bottom">Training</div>
  </div>
);

const PlayStoreIcon = () => (
  <svg viewBox="0 0 24 24" className="app-launch__store-icon" aria-hidden="true">
    <path fill="#34A853" d="M3 20.5V3.5c0-.59.34-1.11.84-1.35L13.69 12 3.84 21.85A1.5 1.5 0 0 1 3 20.5Z" />
    <path fill="#4285F4" d="m16.81 15.12-10.76 6.22 8.49-8.49 2.27 2.27Z" />
    <path fill="#FBBC04" d="M20.16 10.81c.34.27.59.69.59 1.19s-.25.92-.59 1.19l-2.27 1.31L15.39 12l2.5-2.5 2.27 1.31Z" />
    <path fill="#EA4335" d="M6.05 2.66 16.81 8.88l-2.27 2.27-8.49-8.49Z" />
  </svg>
);

const PortfolioPage = () => {
  const [showLaunchScreen, setShowLaunchScreen] = useState(true);

  useEffect(() => {
    const originalOverflow = document.body.style.overflow;
    document.body.style.overflow = showLaunchScreen ? "hidden" : "";

    return () => {
      document.body.style.overflow = originalOverflow;
    };
  }, [showLaunchScreen]);

  useEffect(() => {
    if (!showLaunchScreen) {
      return undefined;
    }

    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        setShowLaunchScreen(false);
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [showLaunchScreen]);

  const handleEnterPortfolio = () => {
    setShowLaunchScreen(false);
    window.requestAnimationFrame(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    });
  };

  return (
    <>
      {showLaunchScreen && (
        <section className="app-launch" role="dialog" aria-modal="true" aria-labelledby="app-launch-title">
          <button type="button" className="app-launch__portfolio-corner" onClick={handleEnterPortfolio}>
            Portfolio
          </button>

          <div className="app-launch__panel">
            <div className="app-launch__copy">
              <div>
                <div className="app-launch__brand-block">
                  <img src={Logo26} alt="501 Dart League" className="app-launch__hero-logo" />
                  <div className="app-launch__brand-copy">
                    <h1 id="app-launch-title" className="app-launch__brand-title">
                      501 Dart League
                    </h1>
                  </div>
                </div>
                <p className="app-launch__lead">
                  Resultados, clasificaciones, campeonatos y estadísticas en web y app, conectados al backend real de 501 Dart League.
                </p>

                <ul className="app-launch__benefit-list" aria-label="Funciones destacadas">
                  {launchBenefits.map((benefit) => (
                    <li key={benefit} className="app-launch__benefit-item">
                      {benefit}
                    </li>
                  ))}
                </ul>
              </div>

              <div className="app-launch__actions">
                <Link to="/501DartLeague" className="app-launch__button app-launch__button--primary">
                  Entrar a la Web App
                </Link>
                <a
                  href="https://play.google.com/store/apps/details?id=com.dartsgame.esp501"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="app-launch__button app-launch__button--store"
                >
                  <PlayStoreIcon />
                  <span className="app-launch__store-copy">
                    <small>Disponible en</small>
                    <strong>Google Play</strong>
                  </span>
                </a>
              </div>

              <p className="app-launch__footnote">Control competitivo, imagen profesional y acceso rápido desde cualquier dispositivo.</p>
            </div>

            <div className="app-launch__visual-column" aria-hidden="true">
              <AppLaunchVisual />
            </div>
          </div>
        </section>
      )}

      <main className="portfolio-page-shell">
        <Header />
        <section id="home">
          <Home />
        </section>
        <section id="portfolio">
          <Portfolio />
        </section>
        <section id="contact">
          <Contact />
        </section>
      </main>
      <Footer />
    </>
  );
};

export default PortfolioPage;
